export default __webpack_public_path__ + "static/media/product.325e31a1.png";